import { Component, OnInit } from '@angular/core';
import { ProductService } from '@app/services/Product/product.service';
import { Paging } from '@app/model/paging';
import { ProductPaginData } from '@app/model/product-pagin-data';
import { ActivatedRoute } from '@angular/router';
import { LoaderService } from '@app/services/loader/loader.service';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.css'],
})
export class ProductListComponent implements OnInit {
  productList: any;
  filteredProducts: any[] = [];
  currentIndex = -1;
  totalCount: number = 0;
  pagination: number = 1;
  itemsPerPage:number =10;

  searchName:any;
  searchCategory:any;

  //#1 Hide product pager and sort section for product details.
  public router: string = '';

  constructor(
    private route: ActivatedRoute,
    private loader: LoaderService,
    private productService: ProductService) { 

    //#1 Hide product pager and sort section for product details.
    // router.events.subscribe((val) => {
    //   if (location.path() != '') {
    //     this.router = location.path().slice(0,16);
    //   } 
    // });
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.searchName = params['name'];
      this.searchCategory = params['id'];

      if(!this.searchName && !this.searchCategory){
        this.getProducts(); 
      } else {
        this.headerSearchByTitle(this.searchName, this.searchCategory)
      }
    });
  }
 
  // Get all products
  getProducts() : void {
    let filterObj: Paging = new Paging();
    let productPagingObj: ProductPaginData = new ProductPaginData();
    this.productService.getAllSellerProducts(filterObj).subscribe({
      next: (res) => {
        productPagingObj.Products = res as ProductPaginData ;
        this.productList = productPagingObj.Products;
        this.filteredProducts = this.productList?.data;
        this.totalCount = this.productList?.data.length;
      }
    }
    );
  }

  //Filter product by name / category / country
  async applyFilter(filterCriteria:any): Promise<void> {
    filterCriteria = {
      name: filterCriteria.name,
      category: filterCriteria.category,
      subCategory: filterCriteria.subCategory,
      country: filterCriteria.country,
      state: filterCriteria.state,
      district: filterCriteria.district
    }; 

    if(filterCriteria.name || filterCriteria.category || filterCriteria.country){
      await this.productListByFilter(filterCriteria);
    } else {
      this.getProducts();
      //this.filteredProducts = this.productList?.data;
      this.totalCount = this.filteredProducts.length;
    }
  }

  filterCriteria:any;
  //Filter product by name 
  async findByTitle(name:any): Promise<void> {
    this.filterCriteria = {
      name: name,
      category: null,
      subCategory: null,
      country: null,
      state: null,
      district: null
    }; 
    
    if(name){
      await this.productListByFilter(this.filterCriteria);
      // this.businessService.searchBusinessByNameId(name, category, filterObj).subscribe()
    } else {
      this.getProducts();
      //this.filteredBusiness = this.businessList?.data;
      this.totalCount = this.filteredProducts.length;
    }
  }
  
  //Search by name for header 
  async headerSearchByTitle(name:any, category:any): Promise<void>  {
    this.filterCriteria = {
      name: name,
      category: category,
      subCategory: null,
      country: null,
      state: null,
      district: null
    }; 
    
    if(name || category){
      await this.productListByFilter(this.filterCriteria);
      // this.businessService.searchBusinessByNameId(name, category, filterObj).subscribe()
    } else {
      this.getProducts();
      //this.filteredBusiness = this.businessList?.data;
      this.totalCount = this.filteredProducts.length;
    }
  }

  // Common method for search and filter
  productListByFilter(filterCriteria:any){
    let filterObj: Paging = new Paging();
    let productPagingObj: ProductPaginData = new ProductPaginData();
    this.productService.filterProduct(filterObj, filterCriteria).subscribe({
      next: (res) => {
        productPagingObj.Products = res as ProductPaginData ;
        this.productList = productPagingObj.Products;
        if(this.productList?.data.length > 0){
          this.filteredProducts = this.productList?.data;
          this.totalCount = this.productList?.data.length;
        } else {
          this.filteredProducts = this.productList?.data;
          this.totalCount = 0;
        }
      }
    });
  }
  
  //Filter product by name / category / country
  // applyFilter(filterCriteria:any): void {
  //   filterCriteria = {
  //     name: filterCriteria.name,
  //     category: filterCriteria.category,
  //     subCategory: filterCriteria.subCategory,
  //     country: filterCriteria.country,
  //     state: filterCriteria.state,
  //     district: filterCriteria.district
  //   };

  //   if(filterCriteria.name || filterCriteria.category || filterCriteria.country){
  //     this.filteredProducts = this.productList?.data.filter((product:any) =>
  //       product.sellProductTitle.toLowerCase().includes(filterCriteria.name.toLowerCase()) ||
  //       product.sellProductCategory === filterCriteria.category &&
  //       product.sellProductSubCategory === filterCriteria.subCategory || 
  //       product.sellProductCountry === filterCriteria.country || 
  //       product.sellProductState === filterCriteria.state && 
  //       product.sellProductDistrict.toLowerCase().includes(filterCriteria.district.toLowerCase())
  //     );
  //     this.totalCount = this.filteredProducts.length;
  // } else {
  //     this.getProducts();
  //     //this.filteredProducts = this.productList?.data;
  //     this.totalCount = this.filteredProducts.length;
  // }
  // }
  
  sortBy(e:any){
    var order= e.target.value;
    switch (e.target.value) {
      case "asc": {
        this.filteredProducts.sort((a:any, b:any) => {
          return order === 'asc'
              ? a.sellProductTitle.localeCompare(b.sellProductTitle)
              : b.sellProductTitle.localeCompare(a.sellProductTitle);
        });
        break;
      }
      case "desc": {
        this.filteredProducts.sort((a:any, b:any) => {
          return order === 'desc'
              ? b.sellProductTitle.localeCompare(a.sellProductTitle)
              : a.sellProductTitle.localeCompare(b.sellProductTitle);
          });
          break;
      }
      case "low": {
        this.filteredProducts.sort((a:any, b:any) => {
          return order === 'low'
              ? a.sellProductPrice - b.sellProductPrice 
              : b.sellProductPrice - a.sellProductPrice;
          });
          break;
      }
      case "high": {
      this.filteredProducts.sort((a:any, b:any) => {
        return order === 'high'
            ? b.sellProductPrice - a.sellProductPrice 
            : a.sellProductPrice - b.sellProductPrice;
        });
      }
    }
  }
  
  //Pager
  renderPage(event: number) {
    this.pagination = event;
    this.getProducts();
    window.scroll(0,0);
  }
}
